import styled from 'styled-components';

import { fontBold } from '../layout/font';

export const UtilityTextRight = styled.div`
  text-align: right;
`;

export const UtilityFontSizeSmall = styled.span`
  font-size: 0.875rem;
`;

export const UtilityTextPrimary = styled.span`
  color: var(--element-color, ${(props) => props.theme.color.primary});
`;

export const UtilityTextBold = styled.span`
  ${fontBold};
`;
